module.exports = __webpack_public_path__ + "static/media/display-1.70b417e6.png";